import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotToastRef } from '@ngxpert/hot-toast';
import { YoutubeThumbnailComponent } from '../../youtube-thumbnail/youtube-thumbnail.component';

const toastMessages: string[] = [
  'lisas just loo listi',
  'sokutas värske pala listi',
  'viskas ühe loo juurde',
  'täiendas listi uue looga',
  'pani värske loo nimekirja',
  'krabas loo ja viskas listi',
  'saatis värske loo otse listi',
  'toppis loo playlisti',
  'smuugeldas uue hiti listi',
  'tõi uue loo listi',
  'poetas loo playlisti',
  'täiendas nimekirja värske palaga',
  'suskas loo listi sekka',
  'lennutas uue loo esitusloendisse',
  'lisas veel ühe loo juurde',
  'pani ühe pala listi kirja',
  'virutas värske loo nimekirja',
];

@Component({
  selector: 'video-added',
  imports: [CommonModule, YoutubeThumbnailComponent],
  templateUrl: './video-added.component.html',
  styleUrl: './video-added.component.scss',
})
export class VideoAddedComponent {
  public message: string;
  // Ehk teeme youtube-thumbnail generic toasti? vb soovime näidata ka now playing läbi websocketi?
  constructor(@Optional() @Inject(HotToastRef) public toast: HotToastRef<any>) {
    this.message =
      toastMessages[Math.floor(Math.random() * toastMessages.length)];
  }
}
